export * from './map-content-item-to-article';
